import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {Product} from "../../../../store/state/order.state";
import {ChangeSet} from "../../history/order-history.model";

@Component({
    selector: 'recertification-additional-questions-details',
    templateUrl: './recertification-additional-questions-details.template.html',
    styleUrls: ['./recertification-additional-questions-details.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RecertificationAdditionalQuestionsDetailsComponent {

	readonly RANDOM_NUMBER: number = Math.random();

	@Input() product: Product;
	@Input() changeSet: ChangeSet;	// optional

	isDesiredNextAuditDateChanged(): boolean {
		return !!this.changeSet && this.additionalQuestionsChangesPresent() && !!this.additionalQuestionsChanges().desiredNextAuditDate;
	}

	private additionalQuestionsChanges() {
		return this.changeSet.changes.productChanges[this.product.standard.name].additionalQuestions;
	}

	private additionalQuestionsChangesPresent() {
		return !!this.changeSet.changes.productChanges[this.product.standard.name] && !!this.changeSet.changes.productChanges[this.product.standard.name].additionalQuestions;
	}

}
